import {$clientApi} from "../http";
import {IPackage, IPackagePriceResponse, IRequestForGetPackagePrice} from "../models/Package";

class PlansServiceClass {

    async getAllPackage() {
        return $clientApi.get<IPackage[]>("api/public/packages");
    }

    async getPackagePrice(model: IRequestForGetPackagePrice) {
        let queryParams = `createIntent=0&customerId=${model.customerId}&poID=${model.packageOptionId}`
        if (model.couponCode) {
            queryParams += `&couponCode=${model.couponCode}`
        }
        if (model.loyaltyExchangeId) {
            queryParams += `&loyaltyExchangeId=${model.loyaltyExchangeId}`
        }
        return $clientApi.get<IPackagePriceResponse>(`api/online-payment/order-details?${queryParams}`);
    }

}

export const PlansService = new PlansServiceClass();